"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _index = require("@/utils/index.js");
var _popupTypes = require("@/utils/popupTypes.js");
var _memberManagement = require("@/api/member/memberManagement.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MenuPagePopup',
  data: function data() {
    return {
      // 搜索表单
      searchForm: {
        page: 1,
        limit: 10,
        total: 0,
        title: '',
        param: '',
        // 门店筛选
        shopId: '',
        // 弹窗类型
        popType: _popupTypes.PopupTypes.POP_TYPE.MENU,
        recommendType: '',
        // 状态筛选
        status: ''
      },
      imagePrefix: '',
      // 活动标签页
      activeTab: '0',
      loading: false,
      // 树状门店数据
      storeTreeData: [],
      // 门店映射表
      shopMap: new Map(),
      // 页面路径到页面名称的映射
      pageMap: new Map(),
      // 弹窗相关数据
      dialogVisible: false,
      currentShopIds: [],
      tableData: [],
      // CDP分组类型映射
      cdpGrpTypeMap: {
        0: '不匹配',
        1: 'CDP分组',
        2: '消费行为'
      },
      // CDP分组类型标签样式映射
      cdpGrpTypeTagMap: {
        0: 'info',
        1: 'success',
        2: 'warning'
      }
    };
  },
  mounted: function mounted() {
    // 获取门店数据
    this.getShopList();
    // 获取列表数据
    this.fetchList();
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
  },
  methods: {
    // 获取图片资源前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              console.log('获取图片前缀响应：', response);
              if (response.code === 200) {
                this.imagePrefix = response.data;
                console.log('获取图片前缀成功：', this.imagePrefix);
              } else {
                console.error('获取图片前缀失败：', response.message);
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀错误：', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取页面列表并构建映射
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                // 构建页面路径到页面名称的映射
                response.data.forEach(function (page) {
                  _this.pageMap.set(page.id, page.pageName);
                });
                console.log('页面映射构建成功:', this.pageMap);
              } else {
                console.error('获取页面列表失败:', response.message);
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取页面列表错误:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 获取门店列表
    getShopList: function () {
      var _getShopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _popupConfig.getShops)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                this.storeTreeData = response.data;
                // 构建门店映射表
                this.shopMap = this.buildShopMap(response.data);
              } else {
                this.$message.error('获取门店列表失败');
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取门店列表错误：', _t3);
              this.$message.error('获取门店列表失败');
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getShopList() {
        return _getShopList.apply(this, arguments);
      }
      return getShopList;
    }(),
    // 把树形结构拍平为 id -> label 的 Map
    buildShopMap: function buildShopMap(tree) {
      var map = new Map();
      function traverse(nodes) {
        nodes.forEach(function (node) {
          // 如果有children，递归处理子节点
          if (node.children && node.children.length > 0) {
            traverse(node.children);
          }
          // 如果是门店节点（有storeId），则添加到映射表中
          if (node.storeId !== undefined) {
            map.set(node.storeId, node.shopName);
          }
        });
      }
      traverse(tree);
      return map;
    },
    getShopName: function getShopName(shopId) {
      if (!shopId) return '全部门店';
      // 使用已构建的门店映射表
      return this.shopMap.get(Number(shopId)) || '未知门店';
    },
    // 获取所有门店数据（只展示children中的数据）
    getAllShops: function getAllShops() {
      var allShops = [];
      if (this.storeTreeData && this.storeTreeData.length > 0) {
        this.storeTreeData.forEach(function (group) {
          if (group.children && group.children.length > 0) {
            allShops.push.apply(allShops, (0, _toConsumableArray2.default)(group.children));
          }
        });
      }
      return allShops;
    },
    // 判断是否选择了所有门店
    isAllShopsSelected: function isAllShopsSelected(selectedShopIds) {
      // 获取所有门店的ID
      var allShops = this.getAllShops();
      var allShopIds = allShops.map(function (shop) {
        return String(shop.storeId);
      });

      // 如果选择的门店数量等于所有门店数量，则认为是选择了全部门店
      if (selectedShopIds.length === allShopIds.length) {
        // 进一步检查选择的门店是否包含所有门店
        return selectedShopIds.every(function (id) {
          return allShopIds.includes(String(id));
        });
      }
      return false;
    },
    // 根据推荐类型获取文本
    getTypeText: function getTypeText(type) {
      var typeMap = {
        1: 'NOTHING',
        2: '领券弹窗',
        3: '系统弹窗',
        4: '直接跳转',
        5: '调查问卷',
        6: '外部小程序',
        7: '微信红包封面'
      };
      return typeMap[type] || '未知类型';
    },
    // 获取推荐内容
    getRecommendContent: function getRecommendContent(row) {
      // 选页面类型(3/4/8)及外部小程序-社区：recommendContentId 为页面ID，尝试获取对应的页面名称
      if (row.recommendType == 3 || row.recommendType == 4 || row.recommendType == 6 || row.recommendType == 8) {
        // 检查是否有对应的页面名称
        var pageInfo = this.pageMap.get(Number(row.recommendContentId));
        if (pageInfo) {
          return this.appendParam(pageInfo, row);
        }
      }

      // 外部小程序-其他：recommendContent 为appid，recommendContentId 为跳转地址
      if (row.recommendContentId != null && row.recommendContent != null && row.recommendContentId != '') {
        return this.appendParam(row.recommendContent + "/" + row.recommendContentId, row);
      } else if (row.recommendContentId != null && row.recommendContentId != '') {
        return this.appendParam(row.recommendContentId, row);
      }
      return this.appendParam(row.recommendContent, row);
    },
    // 拼接参数
    appendParam: function appendParam(content, row) {
      if (content && row.recommendContentParam != null && row.recommendContentParam !== '') {
        return content + '?' + row.recommendContentParam;
      }
      return content;
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 标签页切换
    handleTabChange: function handleTabChange(value) {
      this.searchForm.recommendType = value;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 获取分组类型标签样式
    getCdpGrpTypeTagType: function getCdpGrpTypeTagType(cdpGrpType) {
      return this.cdpGrpTypeTagMap[cdpGrpType] || 'info';
    },
    // 获取分组类型文本
    getCdpGrpTypeText: function getCdpGrpTypeText(cdpGrpType) {
      return this.cdpGrpTypeMap[cdpGrpType] || '不匹配';
    },
    // 获取数据
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      // 调用API获取数据
      (0, _popupConfig.getPopupConfigPage)(this.searchForm).then(function (response) {
        // 根据实际返回的数据结构调整
        if (response.records) {
          _this2.tableData = response.records.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              // 映射字段名以匹配组件使用
              showStartTime: item.showStartTime || item.startTime || '',
              showEndTime: item.showEndTime || item.endTime || '',
              isEnable: item.isEnable !== undefined ? item.isEnable : false,
              isShow: item.isShow !== undefined ? item.isShow : true,
              recommendPriority: item.recommendPriority !== undefined ? item.recommendPriority : 0,
              showImage: item.showImage || item.image || '',
              recommendType: item.recommendType || item.type || 1,
              shopIds: item.shopIds ? item.shopIds.split(',') : [],
              // CDP分组相关字段
              cdpGrpType: item.cdpGrpType !== undefined ? item.cdpGrpType : 0,
              cdpGrpId: item.cdpGrpId || null,
              storeJoinType: item.storeJoinType || 1
            });
          });
          _this2.searchForm.total = response.total || 0;
        } else {
          _this2.tableData = [];
          _this2.searchForm.total = 0;
        }
        _this2.loading = false;
      }).catch(function (error) {
        console.error('获取弹窗配置列表失败:', error);
        _this2.$message.error('获取弹窗配置列表失败');
        _this2.tableData = [];
        _this2.searchForm.total = 0;
        _this2.loading = false;
      });
    },
    // 保存或修改弹窗配置
    saveOrUpdatePopup: function saveOrUpdatePopup(popupData) {
      var _this3 = this;
      return (0, _popupConfig.saveOrUpdatePopupConfig)(popupData).then(function (response) {
        _this3.$message.success('保存成功');
        _this3.fetchList(); // 保存成功后刷新列表
        return response;
      }).catch(function (error) {
        console.error('保存弹窗配置失败:', error);
        _this3.$message.error('保存弹窗配置失败');
        throw error;
      });
    },
    // 删除弹窗配置
    removePopupConfig: function removePopupConfig(id) {
      var _this4 = this;
      return (0, _popupConfig.deletePopupConfig)(id).then(function (response) {
        _this4.$message.success('删除成功');
        _this4.fetchList(); // 删除成功后刷新列表
        return response;
      }).catch(function (error) {
        console.error('删除弹窗配置失败:', error);
        _this4.$message.error('删除弹窗配置失败');
        throw error;
      });
    },
    // 更新弹窗配置状态
    updatePopupStatus: function updatePopupStatus(id, isEnable) {
      var _this5 = this;
      return (0, _popupConfig.updatePopupConfigStatus)(id).then(function (response) {
        _this5.$message.success("\u5DF2".concat(isEnable ? '启用' : '禁用', "\u5F39\u7A97\u914D\u7F6E"));
        return response;
      }).catch(function (error) {
        console.error('更新弹窗配置状态失败:', error);
        _this5.$message.error('更新弹窗配置状态失败');
        // 恢复开关状态
        var popup = _this5.tableData.find(function (item) {
          return item.id === id;
        });
        if (popup) {
          popup.isEnable = !isEnable;
        }
        throw error;
      });
    },
    // 更新弹窗展示状态
    updatePopupShowStatus: function updatePopupShowStatus(id, isShow) {
      var _this6 = this;
      return (0, _popupConfig.updatePopupShowStatus)(id).then(function (response) {
        _this6.$message.success("\u5DF2".concat(isShow ? '展示' : '隐藏', "\u5F39\u7A97\u914D\u7F6E"));
        return response;
      }).catch(function (error) {
        console.error('更新弹窗展示状态失败:', error);
        _this6.$message.error('更新弹窗展示状态失败');
        // 恢复开关状态
        var popup = _this6.tableData.find(function (item) {
          return item.id === id;
        });
        if (popup) {
          popup.isShow = !isShow;
        }
        throw error;
      });
    },
    // 添加弹框
    handleAdd: function handleAdd() {
      this.$emit('add-popup', 'menuPage');
    },
    // 状态切换
    handleStatusChange: function handleStatusChange(row) {
      this.updatePopupStatus(row.id, row.isEnable);
    },
    // 展示状态切换
    handleShowChange: function handleShowChange(row) {
      this.updatePopupShowStatus(row.id, row.isShow);
    },
    // 复制
    handleCopy: function handleCopy(row) {
      this.$emit('add-popup', 'menuPage', row.id);
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      // 传递编辑数据给父组件
      this.$emit('edit-popup', 'menuPage', row.id);
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this7 = this;
      this.$confirm('确定要移除此弹窗配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.removePopupConfig(row.id);
      }).catch(function () {
        _this7.$message.info('已取消移除');
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    // 显示所有门店
    showAllShops: function showAllShops(row) {
      this.currentShopIds = row.shopIds;
      this.dialogVisible = true;
    },
    // 关闭门店弹窗
    closeShopDialog: function closeShopDialog() {
      this.dialogVisible = false;
      this.currentShopIds = [];
    }
  }
};